import { MediaItem } from "@/components/common/MediaItem";

import { CtaButton } from "./CtaButton";

import type { AdsLandingHero, AdsLandingMedia, AdsLandingPageExperimentParameters } from "./types";

export function Hero({
  hero,
  experimentParameters,
}: {
  hero: AdsLandingHero;
  experimentParameters: AdsLandingPageExperimentParameters;
}) {
  const headline = experimentParameters.heroHeaderText || hero.headline;
  const subhead = experimentParameters.heroSubheaderText || hero.subhead;

  return (
    <section className="w-full pt-[120px]">
      <div
        className={`mx-auto flex w-full max-w-[1280px] flex-col gap-8 lg:flex-row lg:gap-6 lg:px-6 ${experimentParameters.heroAlignmentClass}`}
      >
        <div className="flex min-w-0 flex-1 flex-col items-center gap-8 px-6 lg:items-start lg:px-0">
          <div className="text-primary flex flex-col gap-6 text-center lg:pr-[100px] lg:text-left">
            <h1 className="text-[64px] leading-none font-medium">{headline}</h1>
            {subhead ?
              <p className="text-[17px] leading-7 text-balance">{subhead}</p>
            : null}
          </div>

          {hero.ctas.length > 0 ?
            <div className="flex flex-wrap items-center justify-center gap-3 lg:justify-start">
              {hero.ctas.map((cta, index) => (
                <CtaButton
                  key={`${cta.label}-${cta.variant}`}
                  cta={
                    index === 0 && experimentParameters.heroCtaText ?
                      { ...cta, label: experimentParameters.heroCtaText }
                    : cta
                  }
                  showTrailingIcon={cta.variant === "secondary"}
                />
              ))}
            </div>
          : null}
        </div>

        {hero.media ?
          <div className="w-full min-w-0 flex-1 lg:max-w-[596px]">
            <HeroMedia media={hero.media} />
          </div>
        : null}
      </div>
    </section>
  );
}

function HeroMedia({ media }: { media: AdsLandingMedia }) {
  return <MediaItem {...media} ratio={media.ratio ?? "1/1"} className="w-full lg:rounded-[6px]" />;
}
